export const apiName: string = 'funcionarios';

export const funcionariosQueryComPessoa: any = {"Pessoa":{"nome":{"regexp":"/REPLACEHERE/i"},"ativo":true},"ativo":true};



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/funcionarios/data.service.ts
 **/